import { render, staticRenderFns } from "./AddMedias.vue?vue&type=template&id=5136e802&"
import script from "./AddMedias.vue?vue&type=script&lang=js&"
export * from "./AddMedias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports